<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<figure class="img90"><a epub:type="pagebreak" id="page_8"><img alt="Image" src="images/f0008-01.jpg"/>
<figcaption></figcaption>
</a></figure><a epub:type="pagebreak" id="page_8">
</a></section><a epub:type="pagebreak" id="page_8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?62de2e46